import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DbTableDefinitionComponent} from './dbTableDefinition.component';
import {GenericModalModule} from '../modal/generic-modal.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        GenericModalModule
    ],
    declarations: [DbTableDefinitionComponent
    ],
    exports: [
        DbTableDefinitionComponent
    ],
    providers: []
})

export class DbTableDefinitionModule {
}
